module.exports = __webpack_public_path__ + "static/img/man-wearing-black-suit-2955376.7b014674.jpg";